// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Cormorant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Cormorant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/EBGaramond-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/HelveticaNeueRoman.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/HelveticaNeueBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Raleway-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Cormorant-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Cormorant-Reg';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Garamond-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Garamond-Reg';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Helvetica-Reg';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Helvetica-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Raleway-Reg';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Raleway-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAyD;IACzD,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,+DAA4D;IAC5D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,+DAA0D;IAC1D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,+DAA4D;IAC5D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,+DAA6D;IAC7D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,+DAA4D;IAC5D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,+DAA0D;IAC1D,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,+DAAuD;IACvD,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: 'Cormorant-Bold';\n    src: url('./fonts/Cormorant-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Cormorant-Reg';\n    src: url('./fonts/Cormorant-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Garamond-Bold';\n    src: url('./fonts/EBGaramond-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Garamond-Reg';\n    src: url('./fonts/Cormorant-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Helvetica-Reg';\n    src: url('./fonts/HelveticaNeueRoman.otf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Helvetica-Bold';\n    src: url('./fonts/HelveticaNeueBold.otf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Raleway-Reg';\n    src: url('./fonts/Raleway-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Raleway-Bold';\n    src: url('./fonts/Raleway-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
